export const mustBeFilled = (message?: string) => (value: string) => {
  const msg = message || 'Ce champ est obligatoire';
  if (typeof value === 'string') {
    return value.trim() ? undefined : msg;
  }
  const notFalsey = value || value === 0 || value === false;
  return !notFalsey ? msg : undefined;
};
